<template>
  <div class="event-edit-participant-modal-component p-2">
    <div class="d-flex align-items-center justify-content-between">
      <h3>Editar dados</h3>
      <button
        class="btn btn-circle btn-20 bg-neutral-048"
        @click="$emit('close')"
      >
        <i class="fa-regular fa-xmark fs-14" />
      </button>
    </div>

    <div class="d-flex flex-row justify-content-between pt-4">
      <bp-input
        label="Nome novo"
        class="pr-2"
        v-model="data.shopper_name"
        placeholder="Digite o novo nome"
      />

      <bp-input
        label="E-mail novo"
        class="pl-2"
        v-model="data.shopper_email"
        placeholder="Digite o novo e-mail"
      />
    </div>

    <div class="d-flex justify-content-end mt-4 pt-2">
      <button
        class="btn btn-secondary btn-new-secondary px-4"
        @click="$emit('close')"
      >
        Cancelar
      </button>
      <button
        class="btn btn-primary btn-primary px-4 ml-2"
        @click="editDetails"
      >
        <loading :show="loading">
          Salvar
        </loading>
      </button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    participant: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      data: { ...this.participant },
      loading: false
    };
  },
  methods: {
    editDetails() {
      this.loading = true;
      let payload = {
        code: this.participant.code,
        data: {
          shopper_email: this.data.shopper_email,
          shopper_name: this.data.shopper_name
        }
      };
      this.$store
        .dispatch("events/editParticipant", payload)
        .then(data => {
          this.loading = false;
          this.$message.success("Participante editado com sucesso!");
          this.$emit("close");
          this.$emit("updatedParticipant", data);
        })
        .catch(() => {
          this.loading = false;
          this.$message.error = "Erro ao editar participante.";
          this.$emit("close");
        });
    }
  }
};
</script>
